export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgRole01 = require("../assets/image_role01.png");
export const iconCheckBox = require("../assets/checkbox.svg");
export const iconCheckBoxChecked = require("../assets/checkbox_checked.svg");
export const listIcon = require("../assets/listIcon.png");
export const gridIcon = require("../assets/gridIcon.png");
export const filterIcon = require("../assets/filterIcon.png");
export const plusIcon = require("../assets/plus_icon.svg");
